module.exports = __webpack_public_path__ + "media/src/images/icons/flags/ukraine-59b1fef4dce4265c5001f4163e222ac3.svg";